import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';
import { Themas } from '@ilteducation/content-registry-types';
import ThemaDialog from '@/components/book/ThemaDialog.vue';

type Props = {
  themas: Themas | undefined;
};
type Emits = {
  (e: 'themasUpdated', newThemas: Themas): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ChooseThemas',
  props: {
    themas: null
  },
  emits: ["themasUpdated"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'themasUpdated', newThemas: Themas): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  themas: Themas | undefined;
}




const primary = ref<string>(props.themas?.primary || '');
const all = ref<string[]>(props.themas?.all || []);

const themaExists = (t: string) => all.value?.includes(t);

const addThema = (thema: string) => {
  if (themaExists(thema)) {
    return;
  }
  all.value = all.value ? [...all.value, thema] : [thema];
};

const removeThema = (t: string) => {
  const index = all.value.indexOf(t);
  if (index !== -1) {
    all.value.splice(index, 1);
  }
  if (primary.value === t) {
    primary.value = '';
  }
};

watch(
  () => props.themas,
  (newVal) => {
    if (newVal) {
      primary.value = newVal.primary;
      all.value = newVal.all;
    }
  },
);

const themas = computed(() => ({ all: all.value, primary: primary.value ?? '' } as Themas));
watch(themas, () => {
  emits('themasUpdated', themas.value);
});

const rules = {
  primaryRequired: computed(() => all.value.length === 0 || primary.value !== '' || 'Choose a primary thema'),
};

return { __sfc: true,props, emits, primary, all, themaExists, addThema, removeThema, themas, rules, ThemaDialog }
}

})